(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   document ready
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {

		/* Open first item */
		$('.faq .faq__item:first-child').addClass('is-active');

		/* Orders open/close */
		const $question = $('.faq__item__question');

		$question.on('click', function(){
			$(this).parents('.faq__item').toggleClass('is-active');
		});
	});

})(jQuery);
